import { actions } from 'react/api/actions/crud';
import { fromJS } from 'immutable';

const initialState = fromJS({});

export default (state = initialState, action) => {
  const { entity } = action.payload || {};

  switch (action.type) {
    case actions.fetchInitialFormValues: {
      return state.mergeDeep({
        [entity]: {
          loadingInitialValues: true
        }
      });
    }

    case actions.fetchInitialFormValuesSuccess: {
      const { values } = action.payload;
      return state.mergeDeep({
        [entity]: {
          loadingInitialValues: false,
          initialValues: values ? values[0] : {}
        }
      });
    }

    case actions.saveForm: {
      return state.mergeDeep({
        [entity]: {
          saving: true,
          saveError: false,
          errorMessage: ''
        }
      });
    }

    case actions.saveFormSuccess: {
      return state.mergeDeep({
        [entity]: {
          saving: false,
          saveSuccess: true
        }
      });
    }

    case actions.saveFormError: {
      const { error, customError } = action.payload;
      let errorMessage = '';
      if (error && error.errorMessages) {
        const { i18nMessage, key } = error.errorMessages[0].resource;
        errorMessage = i18nMessage || key;
      } else {
        errorMessage = customError || 'general.form.unknownError';
      }
      return state.mergeDeep({
        [entity]: {
          saving: false,
          saveError: !customError,
          errorMessage,
          invalidSubmitCustom: true
        }
      });
    }

    case actions.clearFormError: {
      return state.mergeDeep({
        [entity]: {
          saving: false,
          saveError: false,
          errorMessage: null
        }
      });
    }

    case actions.clearFormState: {
      return state.set(entity, {});
    }

    case actions.addFieldCriteria: {
      const { fieldCriteria } = action.payload;
      return state.updateIn([entity], (crud = fromJS({})) => {
        const criteria = crud && crud.get && crud.get('criteria');
        if (crud.toJS) {
          return fromJS({
            ...crud.toJS(), criteria: criteria ? criteria.concat(fieldCriteria) : fieldCriteria
          });
        }
        return fromJS({
          criteria: criteria ? criteria.concat(fieldCriteria) : fieldCriteria
        });
      });
    }

    case actions.invalidSubmitCustom: {
      return state.mergeDeep({
        [entity]: {
          invalidSubmitCustom: action.payload.invalidSubmitCustom
        }
      });
    }

    default: {
      return state;
    }
  }
};
